/**
 * Zod schemas — printable_specs V4 (bascule Gelato 2026-05-17).
 *
 * Source de vérité : Pydantic `PrintableSpecCreateRequest`. Le drift est
 * attrapé par le codegen OpenAPI (`scripts/gen-api.sh`).
 */

import { z } from 'zod'

// Cap aligné sur la colonne DB `varchar(200)` (bump 2026-05-17 — les
// productUids Gelato encadrés avec montage + verre peuvent dépasser 120
// caractères, ex: `framed_poster_mounted_130x180-mm-5x7-inch_white_wood_…`
// fait 121 chars).
const skuField = z
  .string()
  .min(1, 'productUid requis')
  .max(200, 'Maximum 200 caractères')
  .transform((v) => v.trim())

// `attributes` est un objet JSON libre (paper/color/orientation/…). Le
// BE n'enforce pas de schéma — la signature SHA256 dérive du dump
// canonical (sort_keys). Côté FE on s'assure juste que c'est un dict
// `Record<string, string | number | boolean | null>` au minimum.
const attributesField = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean(), z.null()]),
)

export const printableSpecCreateSchema = z.object({
  provider_slug: z.literal('gelato'),
  sku: skuField,
  attributes: attributesField,
  label_override: z
    .string()
    .max(255, 'Maximum 255 caractères')
    .optional()
    .transform((v) => (v === '' ? undefined : v)),
})

export type PrintableSpecCreateValues = z.input<typeof printableSpecCreateSchema>
export type PrintableSpecCreateParsed = z.output<typeof printableSpecCreateSchema>

export const addVariantSchema = z.object({
  sku: skuField,
})

export type AddVariantValues = z.input<typeof addVariantSchema>
